import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './layout.css';
import WhatsAppButton from './Whatsapp';
import ScrollUp from './ScrollUp';

function Layout({ children }) {
  return (
    <>
      <Header />
      <main className="site-main">{children}</main>
      <Footer />
      <div className='floating-button'>
      <div className="whatsapp-button">
          <WhatsAppButton 
            phoneNumber="9663384126" 
            message="Hello! I would like to inquire about your services." 
          />
        </div>
        <div className="scroll-button">
          <ScrollUp />
        </div>
      </div>
      
    </>
  );
}

export default Layout;
